import { Grid } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import AvatarImage from 'ui/Element/Image/Avatar'

const styles = () => ({
  icon: {
    width: '3rem',
    minHeight: '3rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
})

/**
 * Intended to display a person's icon.
 *
 * @param classes
 * @param {Object} props  props for the component
 * @returns {JSX.Element}
 */
const ListItemCellPersonImage = (classes, props = {}) => {
  const { image, id, attachments } = props
  const attachment = image?.attachment?.value?.name
    ? { ...image.attachment, key: image?.value?.attachmentId || image?.id || undefined, api: { ref: 'person' } }
    : { value: { name: '' } }

  return (
    <Grid
      item
      xs={'auto'}
      className={classes.icon}
    >
      <AvatarImage
        shape={'circular'}
        attachment={attachment || id || attachments?.[0]}
        icon={{
          name: 'user',
          size: '1.5rem',
          color: 'gray.400',
          background: 'gray.960',
        }}
      />
    </Grid>
  )
}

export default CellHOC(ListItemCellPersonImage, styles)
